// The dialog takes the focus when it opens: the first field claims it back once the modal has settled, which
// is also what brings the mobile keyboard up
const MODAL_FOCUS_DELAY = 350;

/**
 * Focuses a field of a modal just after it opened, so the field can be typed in straight away on mobile and desktop
 * The delay is the dialog's own opening animation, during which it holds the focus
 */
export function focusInModalWhenSettled(focus: () => void): void {
  window.setTimeout(focus, MODAL_FOCUS_DELAY);
}
